import {Dialog} from '@common/ui/overlays/dialog/dialog';
import {DialogBody} from '@common/ui/overlays/dialog/dialog-body';
import {DialogHeader} from '@common/ui/overlays/dialog/dialog-header';
import {closeDialog} from '@common/ui/overlays/store/dialog-store';
import {Link} from 'react-router-dom';

function NotLoginGuide() {
  return (
    <Dialog dir="rtl">
      <DialogHeader
        onDismiss={() => {
          closeDialog(NotLoginGuide);
          localStorage.setItem('hasSeenNotLoginGuide', 'true');
        }}
      >
        <p className="leading-7">
          تمامی محتوای این وب‌سایت برای کاربران عزیز در ایران کاملاً رایگان است!{' '}
        </p>
      </DialogHeader>
      <DialogBody dir="rtl" className="w-full leading-6">
        <p>
          فقط با یک ثبت‌نام ساده از طریق ایمیل‌های گوگل یا یاهو، می‌توانید به
          هزاران فیلم و سریال بدون سانسور دسترسی داشته باشید.{' '}
        </p>
        <p>
          📌 لطفاً پس از ثبت‌نام، پروفایل و گروه سنی خود را نیز وارد کنید تا
          محتوای مناسب هر رده سنی نمایش داده شود و کودکان از نمایش محتوای
          نامناسب در امان بمانند.{' '}
        </p>
        <p>✨ هدف ما ارائه‌ی محتوای باکیفیت به شماست؛ </p>
        <p>
          اگر از خدمات سایت رضایت دارید، با حمایت و به‌اشتراک‌گذاری آن با
          دوستانتان کمک کنید تا این وب‌سایت همچنان رایگان باقی بماند.{' '}
        </p>
        <p>با سپاس از همراهی و اعتماد شما </p>
        <div className="w-400">
          <p>
            برای اطلاع از آخرین اخبار و اطلاعیه ها و بروزرسانی های سایت لطفاً در
            کانال تلگرامی MDBMAX مشترک شوید
          </p>
          <Link
            to={'https://t.me/MdbMax'}
            target="_blank"
            className="text-base text-[#24A1DE]"
          >
            آدرس کانل تلگرام
          </Link>
        </div>
      </DialogBody>
    </Dialog>
  );
}

export default NotLoginGuide;
